import { fields } from '@codeleap/form'
import { form } from '@codeleap/form'
import { login } from './login'
import { signup } from './signup'
import { t } from '@lingui/core/macro'
import { zodValidator } from '@codeleap/form'
import z from 'zod'

export const editProfile = form('editProfile', {
  email: fields.text(login.fields.email.options),
  first_name: fields.text(signup.fields.first_name.options),
  last_name: fields.text(signup.fields.last_name.options),
  // @ts-ignore
  birthday: fields.date(signup.fields.birthday.options),
  about: fields.text({
    label: t`About`,
    validate: zodValidator(z.string().min(5)),
    placeholder: t`Tell us a bit about yourself`,
    multiline: true,
  }),
  avatar: fields.file(),
})